import React from 'react';
import EfficiencyIcon from '../../../../../Assets/Icons/WMS/workflow.png';
import AccuracyIcon from '../../../../../Assets/Icons/WMS/target.png';
import SatisfactionIcon from '../../../../../Assets/Icons/WMS/good-person.png';

const services = [
  {
    title: 'Boosts Operational Efficiency',
    description:
      'Automation of warehouse tasks reduces manual errors and speeds up order processing with real-time tracking.',
    icon: EfficiencyIcon,
    backgroundColor: '#E0F2FE',
    accentColor: '#0369A1',
  },
  {
    title: 'Improves Inventory Accuracy',
    description:
      'Tracks inventory down to the location, batch, lot, or serial number, eliminating guesswork.',
    icon: AccuracyIcon,
    backgroundColor: '#F3E8FF',
    accentColor: '#7C3AED',
  },
  {
    title: 'Enhances Customer Satisfaction',
    description:
      'Accurate and faster order fulfillment means fewer delays, errors, and returns.',
    icon: SatisfactionIcon,
    backgroundColor: '#D1FAE5',
    accentColor: '#059669',
  },
];

const CapabilityCard = ({ title, description, icon, backgroundColor, accentColor }) => (
  <article
    className="group flex h-full min-w-0 flex-col rounded-2xl border bg-white p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
    style={{
      borderColor: 'rgba(15, 23, 42, 0.08)',
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    }}
  >
    <div
      className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
      style={{ backgroundColor, color: accentColor }}
    >
      <img
        src={icon}
        alt={`${title} icon`}
        className="h-6 w-6 object-contain"
      />
    </div>

    <h3 className="mb-3 text-lg font-bold leading-snug" style={{ color: '#1A2634' }}>
      {title}
    </h3>

    <p className="mt-auto text-sm font-medium leading-6" style={{ color: '#334155', textAlign: 'left' }}>
      {description}
    </p>
  </article>
);

const WMSServices = () => {
  return (
    <section
      aria-labelledby="wms-capabilities-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="wms-capabilities-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Infor WMS Capabilities
        </h2>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <CapabilityCard key={service.title} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WMSServices;
